import React from 'react';
import { Alert } from '@gcc/autobahn-components';
import { MessageContainerDiv } from './styles';

const InfoMessage = message => <MessageContainerDiv><Alert showIcon text={message} type="warning" /></MessageContainerDiv>;

export default InfoMessage;
